import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SalarySignupFormWrapper = styled.div``

export const TitleWrapper = styled.header`
  margin-bottom: ${Spacing.S16};
`

export const Form = styled.form``

export const AddressGroup = styled.div`
  display: flex;
`

export const ZipCodeField = styled.div`
  flex-shrink: 0;
  width: 76px;
  margin-right: ${Spacing.S8};
`

export const CityField = styled.div`
  flex-grow: 1;
`

export const Footer = styled.footer`
  margin-top: ${Spacing.S32};
`

export const FooterInfo = styled.div`
  margin-top: ${Spacing.S8};
`
